export default {
  brewery: 'fairIsleKnittingCircle',
  info_url: 'http://landing.tavour.com/fairIsleKnittingCircle/',
  title: {
    in_progress: '',
    success: 'You Joined the Fair Isle\'s Knitting Circle!',
    subtext: 'Join Fair Isle Brewing\'s award-winning bottle club membership, the Knitting Circle!',
    sub_subtext: 'The Knitting Circle out-of-state membership includes exclusive Knitting Circle ' +
      'club bottles and Fair Isle favorites. There will be 4 releases each year, one every ' +
      'quarter, at $165 per release (including shipping). ' +
      'Thanks for joining and we’ll be in touch with more news! ',
  },
  review: {
    summary: [
      'You are joining the Fair Isle out-of-state bottle club where you will ' +
      'receive exclusive Knitting Circle club bottles along with seasonal releases ' +
      '4 x per year for $165 per release (including shipping).\n' +
      'By Signing up, your credit card will be automatically charged $165. ' +
      'You will have the opportunity to "opt out" before your credit card is ' +
      'charged by emailing support@tavour.com.\n' +
      'You\'ll receive a notification via email when the box has been charged and shipped.',
    ],
    button_text: 'Join The Fair Isle\'s Knitting Circle!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/fair_isle_knitting_circle.js